import styled from "styled-components";
import * as h from "../../_themes/helpers";
import { BaseButton } from "../../BaseButton";

export const Wrapper = styled(BaseButton)`
  border-radius: 50%;
  position: relative;
  background: ${h.getColor("spinButtonBackground", "spinButton.background")};
  color: ${h.getColor("spinButtonForeground", "spinButton.foreground")};

  &:active {
    background: ${h.getPressedColor(
      "spinButtonBackground",
      "spinButton.background"
    )};
    color: ${h.getPressedColor(
      "spinButtonForeground",
      "spinButton.foreground"
    )};
  }

  &[disabled] {
    background: ${h.getDisabledColor(
      "spinButtonBackground",
      "spinButton.background"
    )};
    color: ${h.getDisabledColor(
      "spinButtonForeground",
      "spinButton.foreground"
    )};
  }
`;
